var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDersler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "url(#paint0_linear_1686_745)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 19.5C10.5766 19.5 10.2905 19.6185 10.0795 19.8295C9.86853 20.0405 9.75 20.3266 9.75 20.625C9.75 21.0392 9.41421 21.375 9 21.375C8.58579 21.375 8.25 21.0392 8.25 20.625C8.25 19.9288 8.52656 19.2611 9.01884 18.7688C9.51113 18.2766 10.1788 18 10.875 18H21C21.4142 18 21.75 18.3358 21.75 18.75C21.75 19.1642 21.4142 19.5 21 19.5H10.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 8.25C10.5766 8.25 10.2905 8.36853 10.0795 8.5795C9.86853 8.79048 9.75 9.07663 9.75 9.375V20.625C9.75 20.9234 9.86853 21.2095 10.0795 21.4205C10.2905 21.6315 10.5766 21.75 10.875 21.75H20.25V8.25H10.875ZM10.875 6.75H21C21.4142 6.75 21.75 7.08579 21.75 7.5V22.5C21.75 22.9142 21.4142 23.25 21 23.25H10.875C10.1788 23.25 9.51113 22.9734 9.01884 22.4812C8.52656 21.9889 8.25 21.3212 8.25 20.625V9.375C8.25 8.67881 8.52656 8.01113 9.01884 7.51884C9.51113 7.02656 10.1788 6.75 10.875 6.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_745",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D78C3F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDersler);
export default __webpack_public_path__ + "static/media/dersler.40410c6c93fdf9639ff1578d4f39dd7b.svg";
export { ForwardRef as ReactComponent };